import { ensureDefined } from '@avantia/client-and-server-utilities';
import { StandardFormGroupWidget } from '../../../engineClient/components/widgets/standardFormGroupWidget';
import { HpClientStandardInputTextAndStyle, HpInputControlProps } from '../../../engineClient/types';
import { Addon } from '../../../types/policyTypes';
import { questionIds } from '../../../types/questionConstants';
import { HpClaimsQuestionSetPageProps } from '../../questionSetForm/questionSetPageTypes';

interface AddonWarningCustomControlProps extends HpInputControlProps {
  pageProps: HpClaimsQuestionSetPageProps;
}

export function AddonWarningCustomControl(props: AddonWarningCustomControlProps): JSX.Element | null {
  const { answers, pageProps, id, question, questionText, dataType, answerSource, formatType } = props;
  const { policies } = pageProps;
  ensureDefined(policies, 'policies');
  const policyReference = answers[questionIds.policyInstance].customer as string;
  const selectedPolicy = policies[policyReference];
  const { coverType } = questionIds;
  const { data } = question;
  const { textAndStyle: dataTextAndStyle } = data;
  const textAndStyle = dataTextAndStyle[formatType] as HpClientStandardInputTextAndStyle;
  const selectedCoverType = answers[coverType].customer as string;
  // TODO AL - This needs to check that the addon name is the same that is coming back from the server.
  const selectedAddon = selectedPolicy.addonDetails.availableAddons[selectedCoverType] as Addon;

  if (!selectedAddon) {
    return null;
  }

  return (
    <StandardFormGroupWidget
      textAndStyle={textAndStyle}
      id={id}
      question={question}
      questionText={questionText}
      dataType={dataType}
      control={[]}
      error={undefined}
      answerSource={answerSource}
      subtext={undefined}
      controlType="read-only-text"
      helpInfo={{ infoText: selectedAddon.description }}
    />
  );
}
